/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BellIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BellIcon({
  children,
  viewPath = "/DesignSystem/Svgs/BellIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="BellIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-20GGX7': alignSelf,'--mt-2-20GGX7': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-20GGX7': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-20GGX7': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-20GGX7': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-20GGX7': opacity,'--w-10-20GGX7': typeof width === 'number' ? `${width}px` : width,'--h-11-20GGX7': typeof height === 'number' ? `${height}px` : height,'--a-7-20GGX7': isAnimated ? animation : "none",'--sd-8-20GGX7': isAnimated ? strokeDashoffset : 0,'--sd-9-20GGX7': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="BellIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M6.1 19.8l3-10.7c1.3-4.6 6.1-7.2 10.6-5.9h0c4.6 1.3 7.2 6.1 5.9 10.6l-3 10.7M19.6 27.8c-2.8 1.6-6.4.6-7.9-2.3M3.2 19l22.2 6.3"
 style={{'--f-12-20GGX7': fill,'--s-13-20GGX7': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}